// store.js — UPDATED
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { rootReducer } from "./rootReducer";

// Pehle combined reducer banao
const combinedReducer = combineReducers(rootReducer.reducer);

// RESET_ALL par poora state clear karo
const rootReducerWithReset = (state, action) => {
  if (action.type === "RESET_ALL") {
    state = undefined; // ✅ Sab slices reset ho jayenge
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducerWithReset,
  devTools: rootReducer.devTools,
  middleware: rootReducer.middleware,
});

export const persistor = persistStore(store);
export { store };

export const purgeStore = async () => {
  store.dispatch({ type: "RESET_ALL" }); // Redux state clear
  await persistor.purge(); // localStorage persist clear
  await storage.removeItem("persist:user"); // Extra safety
};
